"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isWalmartAddToCartUrl;
/*
 * Internal util function (not exposed/documented).
 * Check if the given url is a Walmart addToCart url.
 */
function isWalmartAddToCartUrl(url) {
  try {
    var urlObj = new URL(url);
    if (urlObj.hostname === 'goto.walmart.com') {
      urlObj = new URL(urlObj.searchParams.get('u'));
    }
    return urlObj.hostname.includes('walmart.com') && urlObj.pathname === '/cart/addToCart';
  } catch (e) {}
  return false;
}